import {
  addMonths,
  currentMonth,
  type MonthKey,
  monthEnd,
  monthStart,
} from '@horof/shared';

/** The first and last day of a month: `from` / `to` of the filters. */
export const monthRange = (month: MonthKey): [string, string] => [
  monthStart(month),
  monthEnd(month),
];

/** The month when `from`–`to` is exactly one whole month, else null. */
export function wholeMonth(
  from: string | null,
  to: string | null,
): MonthKey | null {
  if (!from || !to || !/^\d{4}-\d{2}-01$/.test(from)) return null;
  const month = from.slice(0, 7) as MonthKey;
  return monthEnd(month) === to ? month : null;
}

/** A month from the address ("2026-10"), or the current one. */
export function parseMonth(value: string | null, now = new Date()): MonthKey {
  return value && /^\d{4}-(0[1-9]|1[0-2])$/.test(value)
    ? (value as MonthKey)
    : currentMonth(now);
}

export const previousMonth = (month: MonthKey) => addMonths(month, -1);
export const nextMonth = (month: MonthKey) => addMonths(month, 1);
